import React from 'react';
import { useInView } from 'react-intersection-observer';

// 出勤流程圖組件
const AttendanceFlowDiagram = () => (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 800 400" className="w-full h-auto">
        {/* 定義漸變和陰影 */}
        <defs>
            <linearGradient id="gradBlue" x1="0%" y1="0%" x2="100%" y2="0%">
                <stop offset="0%" stopColor="#3b82f6" />
                <stop offset="100%" stopColor="#2563eb" />
            </linearGradient>
            <linearGradient id="gradGreen" x1="0%" y1="0%" x2="100%" y2="0%">
                <stop offset="0%" stopColor="#10b981" />
                <stop offset="100%" stopColor="#059669" />
            </linearGradient>
            <linearGradient id="gradRed" x1="0%" y1="0%" x2="100%" y2="0%">
                <stop offset="0%" stopColor="#ef4444" />
                <stop offset="100%" stopColor="#dc2626" />
            </linearGradient>
            <linearGradient id="gradPurple" x1="0%" y1="0%" x2="100%" y2="0%">
                <stop offset="0%" stopColor="#8b5cf6" />
                <stop offset="100%" stopColor="#7c3aed" />
            </linearGradient>
            <linearGradient id="gradOrange" x1="0%" y1="0%" x2="100%" y2="0%">
                <stop offset="0%" stopColor="#f97316" />
                <stop offset="100%" stopColor="#ea580c" />
            </linearGradient>
            <filter id="shadow" x="-20%" y="-20%" width="140%" height="140%">
                <feGaussianBlur in="SourceAlpha" stdDeviation="3" />
                <feOffset dx="2" dy="2" />
                <feComponentTransfer>
                    <feFuncA type="linear" slope="0.2" />
                </feComponentTransfer>
                <feMerge>
                    <feMergeNode />
                    <feMergeNode in="SourceGraphic" />
                </feMerge>
            </filter>
        </defs>

        {/* 背景 */}
        <rect width="800" height="400" fill="#f8fafc" rx="10" ry="10" />

        {/* 標題 */}
        <text x="400" y="40" fontFamily="Arial, sans-serif" fontSize="24" fontWeight="bold" textAnchor="middle" fill="#1e293b">智能出勤管理流程</text>

        {/* 步驟 1: 員工打卡 */}
        <g transform="translate(100, 120)">
            <rect width="120" height="120" rx="60" ry="60" fill="url(#gradBlue)" filter="url(#shadow)" />
            <text x="60" y="70" fontFamily="Arial, sans-serif" fontSize="16" fontWeight="bold" textAnchor="middle" fill="#ffffff">員工打卡</text>
            <circle cx="60" cy="30" r="10" fill="#ffffff" />
            <path d="M60,25 L60,30 L65,35" stroke="#ffffff" strokeWidth="2" fill="none" strokeLinecap="round" strokeLinejoin="round" />

            {/* 圖標：手機 */}
            <rect x="45" y="90" width="30" height="50" rx="3" ry="3" fill="#ffffff" fillOpacity="0.2" stroke="#ffffff" strokeWidth="2" />
            <rect x="50" y="95" width="20" height="35" rx="2" ry="2" fill="#ffffff" fillOpacity="0.3" />
            <circle cx="60" cy="135" r="3" fill="#ffffff" />
        </g>

        {/* 步驟 2: GPS定位驗證 */}
        <g transform="translate(340, 120)">
            <rect width="120" height="120" rx="60" ry="60" fill="url(#gradGreen)" filter="url(#shadow)" />
            <text x="60" y="70" fontFamily="Arial, sans-serif" fontSize="16" fontWeight="bold" textAnchor="middle" fill="#ffffff">定位驗證</text>

            {/* 圖標：GPS位置 */}
            <path d="M60,35 C50,35 42,43 42,53 C42,60 60,85 60,85 C60,85 78,60 78,53 C78,43 70,35 60,35 Z" fill="#ffffff" fillOpacity="0.3" stroke="#ffffff" strokeWidth="2" />
            <circle cx="60" cy="53" r="6" fill="#ffffff" />
        </g>

        {/* 步驟 3: 系統處理 */}
        <g transform="translate(580, 120)">
            <rect width="120" height="120" rx="60" ry="60" fill="url(#gradPurple)" filter="url(#shadow)" />
            <text x="60" y="70" fontFamily="Arial, sans-serif" fontSize="16" fontWeight="bold" textAnchor="middle" fill="#ffffff">系統處理</text>

            {/* 圖標：齒輪 */}
            <circle cx="60" cy="40" r="20" fill="none" stroke="#ffffff" strokeWidth="2" />
            <path d="M60,20 L60,24 M60,56 L60,60 M40,40 L44,40 M76,40 L80,40 M45,25 L48,28 M72,52 L75,55 M45,55 L48,52 M72,28 L75,25" stroke="#ffffff" strokeWidth="2" strokeLinecap="round" />
            <circle cx="60" cy="40" r="6" fill="#ffffff" />
        </g>

        {/* 步驟 4: 異常檢測 */}
        <g transform="translate(250, 280)">
            <rect width="120" height="120" rx="60" ry="60" fill="url(#gradRed)" filter="url(#shadow)" />
            <text x="60" y="70" fontFamily="Arial, sans-serif" fontSize="16" fontWeight="bold" textAnchor="middle" fill="#ffffff">異常檢測</text>

            {/* 圖標：警告 */}
            <path d="M60,35 L78,65 L42,65 Z" fill="none" stroke="#ffffff" strokeWidth="2" />
            <circle cx="60" cy="55" r="4" fill="#ffffff" />
            <line x1="60" y1="42" x2="60" y2="50" stroke="#ffffff" strokeWidth="2" strokeLinecap="round" />
        </g>

        {/* 步驟 5: 數據分析 */}
        <g transform="translate(470, 280)">
            <rect width="120" height="120" rx="60" ry="60" fill="url(#gradOrange)" filter="url(#shadow)" />
            <text x="60" y="70" fontFamily="Arial, sans-serif" fontSize="16" fontWeight="bold" textAnchor="middle" fill="#ffffff">數據分析</text>

            {/* 圖標：圖表 */}
            <rect x="45" y="40" width="5" height="20" fill="#ffffff" />
            <rect x="55" y="30" width="5" height="30" fill="#ffffff" />
            <rect x="65" y="35" width="5" height="25" fill="#ffffff" />
            <rect x="75" y="25" width="5" height="35" fill="#ffffff" />
            <line x1="40" y1="60" x2="85" y2="60" stroke="#ffffff" strokeWidth="2" />
        </g>

        {/* 連接箭頭 */}
        {/* 1 到 2 */}
        <path d="M230,180 L330,180" stroke="#94a3b8" strokeWidth="3" strokeLinecap="round" strokeDasharray="1, 5" />
        <polygon points="320,175 330,180 320,185" fill="#94a3b8" />

        {/* 2 到 3 */}
        <path d="M470,180 L570,180" stroke="#94a3b8" strokeWidth="3" strokeLinecap="round" strokeDasharray="1, 5" />
        <polygon points="560,175 570,180 560,185" fill="#94a3b8" />

        {/* 3 到 4 */}
        <path d="M640,250 L640,270 L320,270 L320,280" stroke="#94a3b8" strokeWidth="3" strokeLinecap="round" strokeDasharray="1, 5" />
        <polygon points="315,270 320,280 325,270" fill="#94a3b8" />

        {/* 3 到 5 */}
        <path d="M640,250 L640,270 L530,270 L530,280" stroke="#94a3b8" strokeWidth="3" strokeLinecap="round" strokeDasharray="1, 5" />
        <polygon points="525,270 530,280 535,270" fill="#94a3b8" />

        {/* 操作説明 */}
        <g transform="translate(160, 80)">
            <text fontFamily="Arial, sans-serif" fontSize="12" fill="#64748b">員工使用APP進行GPS簽到</text>
        </g>

        <g transform="translate(400, 80)">
            <text fontFamily="Arial, sans-serif" fontSize="12" fill="#64748b">系統驗證位置及設備指紋</text>
        </g>

        <g transform="translate(640, 80)">
            <text fontFamily="Arial, sans-serif" fontSize="12" fill="#64748b">記錄生成與數據處理</text>
        </g>

        <g transform="translate(310, 240)">
            <text fontFamily="Arial, sans-serif" fontSize="12" fill="#64748b">識別遲到、早退等異常</text>
        </g>

        <g transform="translate(530, 240)">
            <text fontFamily="Arial, sans-serif" fontSize="12" fill="#64748b">生成報表與數據分析</text>
        </g>
    </svg>
);

// 薪資計算流程圖組件
const SalaryCalculationDiagram = () => (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 800 500" className="w-full h-auto">
        {/* 定義漸變和陰影 */}
        <defs>
            <linearGradient id="blueGrad" x1="0%" y1="0%" x2="100%" y2="0%">
                <stop offset="0%" stopColor="#3b82f6" />
                <stop offset="100%" stopColor="#2563eb" />
            </linearGradient>
            <linearGradient id="greenGrad" x1="0%" y1="0%" x2="100%" y2="0%">
                <stop offset="0%" stopColor="#10b981" />
                <stop offset="100%" stopColor="#059669" />
            </linearGradient>
            <linearGradient id="purpleGrad" x1="0%" y1="0%" x2="100%" y2="0%">
                <stop offset="0%" stopColor="#8b5cf6" />
                <stop offset="100%" stopColor="#7c3aed" />
            </linearGradient>
            <linearGradient id="orangeGrad" x1="0%" y1="0%" x2="100%" y2="0%">
                <stop offset="0%" stopColor="#f97316" />
                <stop offset="100%" stopColor="#ea580c" />
            </linearGradient>
            <linearGradient id="cyanGrad" x1="0%" y1="0%" x2="100%" y2="0%">
                <stop offset="0%" stopColor="#06b6d4" />
                <stop offset="100%" stopColor="#0891b2" />
            </linearGradient>
            <filter id="boxShadow" x="-10%" y="-10%" width="120%" height="120%">
                <feGaussianBlur in="SourceAlpha" stdDeviation="2" />
                <feOffset dx="2" dy="2" />
                <feComponentTransfer>
                    <feFuncA type="linear" slope="0.3" />
                </feComponentTransfer>
                <feMerge>
                    <feMergeNode />
                    <feMergeNode in="SourceGraphic" />
                </feMerge>
            </filter>
        </defs>

        {/* 背景 */}
        <rect width="800" height="500" fill="#f8fafc" rx="10" ry="10" />

        {/* 標題 */}
        <text x="400" y="40" fontFamily="Arial, sans-serif" fontSize="24" fontWeight="bold" textAnchor="middle" fill="#1e293b">智能薪資核算流程</text>

        {/* 步驟1：數據收集 */}
        <g transform="translate(80, 120)">
            <rect width="160" height="80" rx="10" ry="10" fill="url(#blueGrad)" filter="url(#boxShadow)" />
            <text x="80" y="35" fontFamily="Arial, sans-serif" fontSize="16" fontWeight="bold" textAnchor="middle" fill="#ffffff">數據收集</text>
            <text x="80" y="55" fontFamily="Arial, sans-serif" fontSize="12" textAnchor="middle" fill="#ffffff">考勤、請假、加班數據</text>

            {/* 圖標：數據 */}
            <g transform="translate(65, 65)">
                <rect x="0" y="0" width="10" height="10" fill="#ffffff" fillOpacity="0.7" />
                <rect x="15" y="0" width="10" height="10" fill="#ffffff" fillOpacity="0.7" />
                <rect x="30" y="0" width="10" height="10" fill="#ffffff" fillOpacity="0.7" />
                <rect x="0" y="-15" width="10" height="10" fill="#ffffff" fillOpacity="0.7" />
                <rect x="15" y="-15" width="10" height="10" fill="#ffffff" fillOpacity="0.7" />
                <rect x="30" y="-15" width="10" height="10" fill="#ffffff" fillOpacity="0.7" />
            </g>
        </g>

        {/* 步驟2：基本薪資設定 */}
        <g transform="translate(320, 120)">
            <rect width="160" height="80" rx="10" ry="10" fill="url(#greenGrad)" filter="url(#boxShadow)" />
            <text x="80" y="35" fontFamily="Arial, sans-serif" fontSize="16" fontWeight="bold" textAnchor="middle" fill="#ffffff">基本薪資設定</text>
            <text x="80" y="55" fontFamily="Arial, sans-serif" fontSize="12" textAnchor="middle" fill="#ffffff">基本工資、底薪</text>

            {/* 圖標：元 */}
            <circle cx="80" cy="75" r="15" fill="#ffffff" fillOpacity="0.2" stroke="#ffffff" strokeWidth="1" />
            <text x="80" y="80" fontFamily="Arial, sans-serif" fontSize="14" fontWeight="bold" textAnchor="middle" fill="#ffffff">$</text>
        </g>

        {/* 步驟3：加項計算 */}
        <g transform="translate(560, 120)">
            <rect width="160" height="80" rx="10" ry="10" fill="url(#purpleGrad)" filter="url(#boxShadow)" />
            <text x="80" y="35" fontFamily="Arial, sans-serif" fontSize="16" fontWeight="bold" textAnchor="middle" fill="#ffffff">加項計算</text>
            <text x="80" y="55" fontFamily="Arial, sans-serif" fontSize="12" textAnchor="middle" fill="#ffffff">加班費、獎金、津貼</text>

            {/* 圖標：加號 */}
            <circle cx="80" cy="75" r="15" fill="#ffffff" fillOpacity="0.2" stroke="#ffffff" strokeWidth="1" />
            <text x="80" y="80" fontFamily="Arial, sans-serif" fontSize="16" fontWeight="bold" textAnchor="middle" fill="#ffffff">+</text>
        </g>

        {/* 步驟4：減項計算 */}
        <g transform="translate(560, 280)">
            <rect width="160" height="80" rx="10" ry="10" fill="url(#orangeGrad)" filter="url(#boxShadow)" />
            <text x="80" y="35" fontFamily="Arial, sans-serif" fontSize="16" fontWeight="bold" textAnchor="middle" fill="#ffffff">減項計算</text>
            <text x="80" y="55" fontFamily="Arial, sans-serif" fontSize="12" textAnchor="middle" fill="#ffffff">請假扣款、保險費、稅金</text>

            {/* 圖標：減號 */}
            <circle cx="80" cy="75" r="15" fill="#ffffff" fillOpacity="0.2" stroke="#ffffff" strokeWidth="1" />
            <text x="80" y="80" fontFamily="Arial, sans-serif" fontSize="16" fontWeight="bold" textAnchor="middle" fill="#ffffff">-</text>
        </g>

        {/* 步驟5：薪資核對 */}
        <g transform="translate(320, 280)">
            <rect width="160" height="80" rx="10" ry="10" fill="url(#cyanGrad)" filter="url(#boxShadow)" />
            <text x="80" y="35" fontFamily="Arial, sans-serif" fontSize="16" fontWeight="bold" textAnchor="middle" fill="#ffffff">薪資核對</text>
            <text x="80" y="55" fontFamily="Arial, sans-serif" fontSize="12" textAnchor="middle" fill="#ffffff">複核計算結果</text>

            {/* 圖標：複核 */}
            <circle cx="80" cy="75" r="15" fill="#ffffff" fillOpacity="0.2" stroke="#ffffff" strokeWidth="1" />
            <text x="80" y="80" fontFamily="Arial, sans-serif" fontSize="16" fontWeight="bold" textAnchor="middle" fill="#ffffff">✓</text>
        </g>

        {/* 步驟6：薪資發放 */}
        <g transform="translate(80, 280)">
            <rect width="160" height="80" rx="10" ry="10" fill="url(#blueGrad)" filter="url(#boxShadow)" />
            <text x="80" y="35" fontFamily="Arial, sans-serif" fontSize="16" fontWeight="bold" textAnchor="middle" fill="#ffffff">薪資發放</text>
            <text x="80" y="55" fontFamily="Arial, sans-serif" fontSize="12" textAnchor="middle" fill="#ffffff">生成薪資單與發放</text>

            {/* 圖標：文件 */}
            <rect x="70" y="65" width="20" height="25" fill="#ffffff" fillOpacity="0.7" stroke="#ffffff" strokeWidth="1" />
            <path d="M70,65 L80,60 L90,65" fill="none" stroke="#ffffff" strokeWidth="1" />
        </g>

        {/* 連接箭頭 */}
        {/* 1 到 2 */}
        <path d="M250,160 L310,160" stroke="#94a3b8" strokeWidth="2" strokeLinecap="round" />
        <polygon points="300,155 310,160 300,165" fill="#94a3b8" />

        {/* 2 到 3 */}
        <path d="M490,160 L550,160" stroke="#94a3b8" strokeWidth="2" strokeLinecap="round" />
        <polygon points="540,155 550,160 540,165" fill="#94a3b8" />

        {/* 3 到 4 */}
        <path d="M640,210 L640,270" stroke="#94a3b8" strokeWidth="2" strokeLinecap="round" />
        <polygon points="635,260 640,270 645,260" fill="#94a3b8" />

        {/* 4 到 5 */}
        <path d="M550,320 L490,320" stroke="#94a3b8" strokeWidth="2" strokeLinecap="round" />
        <polygon points="500,315 490,320 500,325" fill="#94a3b8" />

        {/* 5 到 6 */}
        <path d="M310,320 L250,320" stroke="#94a3b8" strokeWidth="2" strokeLinecap="round" />
        <polygon points="260,315 250,320 260,325" fill="#94a3b8" />

        {/* 補充說明框 */}
        <g transform="translate(100, 400)">
            <rect width="600" height="60" rx="5" ry="5" fill="#e2e8f0" />
            <text x="300" y="25" fontFamily="Arial, sans-serif" fontSize="14" fontWeight="bold" textAnchor="middle" fill="#1e293b">薪資自動化計算優勢</text>
            <text x="300" y="45" fontFamily="Arial, sans-serif" fontSize="12" textAnchor="middle" fill="#475569">整合考勤與薪資數據，自動計算各項薪資項目，減少人工錯誤，提高計算效率與準確性</text>
        </g>

        {/* 旁注 */}
        <g transform="translate(160, 100)">
            <text fontFamily="Arial, sans-serif" fontSize="12" fill="#64748b">自動收集各類數據</text>
        </g>

        <g transform="translate(400, 100)">
            <text fontFamily="Arial, sans-serif" fontSize="12" fill="#64748b">設定員工基本薪資結構</text>
        </g>

        <g transform="translate(640, 100)">
            <text fontFamily="Arial, sans-serif" fontSize="12" fill="#64748b">計算各項加項薪資</text>
        </g>

        <g transform="translate(640, 370)">
            <text fontFamily="Arial, sans-serif" fontSize="12" fill="#64748b">計算各項扣除項目</text>
        </g>

        <g transform="translate(400, 370)">
            <text fontFamily="Arial, sans-serif" fontSize="12" fill="#64748b">確保計算的正確性</text>
        </g>

        <g transform="translate(160, 370)">
            <text fontFamily="Arial, sans-serif" fontSize="12" fill="#64748b">生成電子薪資單</text>
        </g>
    </svg>
);

// 排班管理流程圖組件
const SchedulingFlowDiagram = () => (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 800 400" className="w-full h-auto">
        {/* 定義漸變和陰影 */}
        <defs>
            <linearGradient id="scheduleBlue" x1="0%" y1="0%" x2="100%" y2="0%">
                <stop offset="0%" stopColor="#3b82f6" />
                <stop offset="100%" stopColor="#2563eb" />
            </linearGradient>
            <linearGradient id="scheduleGreen" x1="0%" y1="0%" x2="100%" y2="0%">
                <stop offset="0%" stopColor="#10b981" />
                <stop offset="100%" stopColor="#059669" />
            </linearGradient>
            <linearGradient id="schedulePurple" x1="0%" y1="0%" x2="100%" y2="0%">
                <stop offset="0%" stopColor="#8b5cf6" />
                <stop offset="100%" stopColor="#7c3aed" />
            </linearGradient>
            <linearGradient id="scheduleOrange" x1="0%" y1="0%" x2="100%" y2="0%">
                <stop offset="0%" stopColor="#f97316" />
                <stop offset="100%" stopColor="#ea580c" />
            </linearGradient>
            <linearGradient id="scheduleTeal" x1="0%" y1="0%" x2="100%" y2="0%">
                <stop offset="0%" stopColor="#14b8a6" />
                <stop offset="100%" stopColor="#0d9488" />
            </linearGradient>
            <filter id="scheduleShadow" x="-10%" y="-10%" width="120%" height="120%">
                <feGaussianBlur in="SourceAlpha" stdDeviation="2" />
                <feOffset dx="2" dy="2" />
                <feComponentTransfer>
                    <feFuncA type="linear" slope="0.2" />
                </feComponentTransfer>
                <feMerge>
                    <feMergeNode />
                    <feMergeNode in="SourceGraphic" />
                </feMerge>
            </filter>
        </defs>

        {/* 背景 */}
        <rect width="800" height="400" fill="#f8fafc" rx="10" ry="10" />

        {/* 標題 */}
        <text x="400" y="40" fontFamily="Arial, sans-serif" fontSize="24" fontWeight="bold" textAnchor="middle" fill="#1e293b">智能排班管理流程</text>

        {/* 中央流程 */}
        {/* 步驟1：設定規則 */}
        <g transform="translate(100, 100)">
            <rect width="120" height="60" rx="10" ry="10" fill="url(#scheduleBlue)" filter="url(#scheduleShadow)" />
            <text x="60" y="30" fontFamily="Arial, sans-serif" fontSize="16" fontWeight="bold" textAnchor="middle" fill="#ffffff">設定規則</text>
            <text x="60" y="45" fontFamily="Arial, sans-serif" fontSize="12" textAnchor="middle" fill="#ffffff">班別與限制條件</text>
        </g>

        {/* 步驟2：人力需求分析 */}
        <g transform="translate(300, 100)">
            <rect width="120" height="60" rx="10" ry="10" fill="url(#scheduleGreen)" filter="url(#scheduleShadow)" />
            <text x="60" y="30" fontFamily="Arial, sans-serif" fontSize="16" fontWeight="bold" textAnchor="middle" fill="#ffffff">需求分析</text>
            <text x="60" y="45" fontFamily="Arial, sans-serif" fontSize="12" textAnchor="middle" fill="#ffffff">人力需求評估</text>
        </g>

        {/* 步驟3：智能排班 */}
        <g transform="translate(500, 100)">
            <rect width="120" height="60" rx="10" ry="10" fill="url(#schedulePurple)" filter="url(#scheduleShadow)" />
            <text x="60" y="30" fontFamily="Arial, sans-serif" fontSize="16" fontWeight="bold" textAnchor="middle" fill="#ffffff">智能排班</text>
            <text x="60" y="45" fontFamily="Arial, sans-serif" fontSize="12" textAnchor="middle" fill="#ffffff">自動排班演算法</text>
        </g>

        {/* 步驟4：手動調整 */}
        <g transform="translate(600, 200)">
            <rect width="120" height="60" rx="10" ry="10" fill="url(#scheduleOrange)" filter="url(#scheduleShadow)" />
            <text x="60" y="30" fontFamily="Arial, sans-serif" fontSize="16" fontWeight="bold" textAnchor="middle" fill="#ffffff">手動調整</text>
            <text x="60" y="45" fontFamily="Arial, sans-serif" fontSize="12" textAnchor="middle" fill="#ffffff">管理者微調結果</text>
        </g>

        {/* 步驟5：發布排班 */}
        <g transform="translate(400, 200)">
            <rect width="120" height="60" rx="10" ry="10" fill="url(#scheduleTeal)" filter="url(#scheduleShadow)" />
            <text x="60" y="30" fontFamily="Arial, sans-serif" fontSize="16" fontWeight="bold" textAnchor="middle" fill="#ffffff">發布排班</text>
            <text x="60" y="45" fontFamily="Arial, sans-serif" fontSize="12" textAnchor="middle" fill="#ffffff">通知員工</text>
        </g>

        {/* 步驟6：數據分析 */}
        <g transform="translate(200, 200)">
            <rect width="120" height="60" rx="10" ry="10" fill="url(#scheduleBlue)" filter="url(#scheduleShadow)" />
            <text x="60" y="30" fontFamily="Arial, sans-serif" fontSize="16" fontWeight="bold" textAnchor="middle" fill="#ffffff">數據分析</text>
            <text x="60" y="45" fontFamily="Arial, sans-serif" fontSize="12" textAnchor="middle" fill="#ffffff">優化未來排班</text>
        </g>

        {/* 連接箭頭 */}
        {/* 1 到 2 */}
        <path d="M230,130 L290,130" stroke="#94a3b8" strokeWidth="2" strokeLinecap="round" />
        <polygon points="280,125 290,130 280,135" fill="#94a3b8" />

        {/* 2 到 3 */}
        <path d="M430,130 L490,130" stroke="#94a3b8" strokeWidth="2" strokeLinecap="round" />
        <polygon points="480,125 490,130 480,135" fill="#94a3b8" />

        {/* 3 到 4 */}
        <path d="M560,170 L590,190" stroke="#94a3b8" strokeWidth="2" strokeLinecap="round" />
        <polygon points="582,183 590,190 586,178" fill="#94a3b8" />

        {/* 4 到 5 */}
        <path d="M590,230 L530,230" stroke="#94a3b8" strokeWidth="2" strokeLinecap="round" />
        <polygon points="540,225 530,230 540,235" fill="#94a3b8" />

        {/* 5 到 6 */}
        <path d="M390,230 L330,230" stroke="#94a3b8" strokeWidth="2" strokeLinecap="round" />
        <polygon points="340,225 330,230 340,235" fill="#94a3b8" />

        {/* 6 到 1 (循環) */}
        <path d="M200,190 L160,170" stroke="#94a3b8" strokeWidth="2" strokeLinecap="round" />
        <polygon points="168,176 160,170 164,182" fill="#94a3b8" />

        {/* 關鍵特性 */}
        <g transform="translate(50, 300)">
            <rect width="700" height="60" rx="5" ry="5" fill="#e2e8f0" />
            <text x="350" y="25" fontFamily="Arial, sans-serif" fontSize="14" fontWeight="bold" textAnchor="middle" fill="#1e293b">排班管理系統特性</text>
            <text x="350" y="45" fontFamily="Arial, sans-serif" fontSize="12" textAnchor="middle" fill="#475569">考慮員工專長、工時限制、休假安排、輪班規則，自動產生最優排班方案，提高人力資源利用效率</text>
        </g>

        {/* 旁注說明 */}
        <g transform="translate(80, 80)">
            <text fontFamily="Arial, sans-serif" fontSize="12" fill="#64748b">設定班別與排班限制條件</text>
        </g>

        <g transform="translate(280, 80)">
            <text fontFamily="Arial, sans-serif" fontSize="12" fill="#64748b">評估不同時段的人力需求</text>
        </g>

        <g transform="translate(480, 80)">
            <text fontFamily="Arial, sans-serif" fontSize="12" fill="#64748b">AI演算法自動產生排班</text>
        </g>

        <g transform="translate(640, 180)">
            <text fontFamily="Arial, sans-serif" fontSize="12" fill="#64748b">人工調整特殊情況</text>
        </g>

        <g transform="translate(440, 180)">
            <text fontFamily="Arial, sans-serif" fontSize="12" fill="#64748b">發送通知給員工</text>
        </g>

        <g transform="translate(240, 180)">
            <text fontFamily="Arial, sans-serif" fontSize="12" fill="#64748b">分析排班效率</text>
        </g>
    </svg>
);

// 通用SVG圖表組件
const SVGDiagram = ({ type, title, description }) => {
    const [ref, inView] = useInView({
        triggerOnce: true,
        threshold: 0.1,
    });

    // 選擇要顯示的圖表組件
    const getDiagramByType = () => {
        switch (type) {
            case 'attendance':
                return <AttendanceFlowDiagram />;
            case 'salary':
                return <SalaryCalculationDiagram />;
            case 'scheduling':
                return <SchedulingFlowDiagram />;
            default:
                return null;
        }
    };

    return (
        <div
            ref={ref}
            className={`mt-12 transition-opacity duration-1000 ease-in-out ${inView ? 'opacity-100' : 'opacity-0'
                }`}
        >
            {(title || description) && (
                <div className="text-center mb-8">
                    {title && <h3 className="text-2xl font-bold mb-2">{title}</h3>}
                    {description && <p className="text-gray-600">{description}</p>}
                </div>
            )}

            <div className="bg-white p-4 rounded-lg shadow-md">
                {getDiagramByType()}
            </div>
        </div>
    );
};

export default SVGDiagram;